import { render, staticRenderFns } from "./BudgetSummary.vue?vue&type=template&id=6f60e65d&scoped=true"
import script from "./BudgetSummary.vue?vue&type=script&lang=js"
export * from "./BudgetSummary.vue?vue&type=script&lang=js"
import style0 from "./BudgetSummary.vue?vue&type=style&index=0&id=6f60e65d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f60e65d",
  null
  
)

export default component.exports